import React, { useState, useEffect } from 'react'
import { Grid, Box, Paper } from '@material-ui/core';
import Controls from "../controls/Controls"
import { useForm, Form } from "../controls/useForm"
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import { Typography, DialogTitle, makeStyles } from '@material-ui/core'
// import { Container } from '@material-ui/core';
import { toast } from "react-toastify";
import { addExternalPBM } from "../services/PerksServices";
import PerksPageLoader from "../components/PerksPageLoader";
import DialogActions from "@material-ui/core/DialogActions";

const initialFValues = {
  extPBMId: '',
  extPBMName: '',
  extPBMUUID: '',
  fromDate: new Date(),
  thruDate: new Date(),
  bin: '',
  pcn: '',
  group: '',
  disocuntCHID: ''
  // user: JSON.parse(sessionStorage.getItem("user-name")),
  // changeUser: JSON.parse(sessionStorage.getItem("user-name"))
}


const useStyles = makeStyles(theme => ({
  dialogWrapper: {
    padding: theme.spacing(1),
    position: 'absolute',
    top: theme.spacing(5)
  },
  dialogTitle: {
    paddingRight: '10px',
    color: '#002677'

  }
}))




export default function AddPBM(props) {



  const classes = useStyles();
  const { addOrEdit, recordForEdit } = props
  const { onClose, open, onSubmit } = props;
  const [enableSubmit, setEnableSubmit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [username, setUsername] = useState();

  useEffect(() => {
    setUsername(JSON.parse(sessionStorage.getItem("user-name")))
  }, []);

  const validate = (fieldValues = values) => {
    let temp = { ...errors }
    if ('extPBMId' in fieldValues)
      temp.extPBMId = fieldValues.extPBMId ? "" : "This field is required."
    if ('extPBMName' in fieldValues)
      temp.extPBMName = fieldValues.extPBMName ? "" : "This field is required."
    if ('extPBMUUID' in fieldValues)
      temp.extPBMUUID = (/^[a-z\d\-]+$/i).test(fieldValues.extPBMUUID) ? "" : "This field is required. Valid values A-Z, a-z, 0-9, -"
    if ('fromDate' in fieldValues)
      temp.fromDate = fieldValues.fromDate ? "" : "This field is required."
    if ('thruDate' in fieldValues)
      temp.thruDate = fieldValues.thruDate ? "" : "This field is required."
    // if (values.fromDate > values.thruDate)
    //   temp.thruDate = "Thru Date cannot be less than From date."
    if (values.fromDate > values.thruDate)
    {
      temp.thruDate = "Thru Date cannot be less than From date."
    }
    if ('bin' in fieldValues)
      temp.bin = /^(\d{6}|\d{8})$/.test(fieldValues.bin) ? "" : "Enter a valid BIN. BIN must contain either 6 or 8 digits."



    setErrors({
      ...temp
    });


    temp.extPBMId === "" && temp.extPBMName === "" && temp.extPBMUUID === ""

      ? setEnableSubmit(true) : setEnableSubmit(false);

    if (fieldValues === values) return Object.values(temp).every(x => x === "");
  }

  const {
    values,
    setValues,
    errors,
    setErrors,
    handleInputChange,

  } = useForm(initialFValues, true, validate);

  const handleSubmit = e => {
    e.preventDefault()
    if (validate()) {

      setLoading(true);
      console.log("values object" + values);
      const extPBMToSave = {
        extPbmId: values.extPBMId,
        extPbmName: values.extPBMName,
        extPbmUuid: values.extPBMUUID,
        fromDate: values.fromDate,
        thruDate: values.thruDate,
        xp3BinNumber: values.bin,
        xp3ControlNumber: values.pcn,
        xp3GroupNumber: values.group,
        xp3DiscountCard: values.disocuntCHID,
        user: username,
        changeUser: username
      };

      console.log("About to save pbm list " + extPBMToSave.fromDate);
      console.log("About to save pbm list " + extPBMToSave.user);
      addExternalPBM(extPBMToSave)
        .then(function (res) {
          console.log("axios result from Add External PBM", res);
          const status = res && res.status;
          const body = res && res.data;
          console.log("status code ", status);
          const bodyStr = typeof body === 'string' ? body : JSON.stringify(body || {});
          const isDuplicate = (() => {
            if (!body) return false;
            try {
              if (typeof body === 'string') return body.toLowerCase().includes('duplicate');
              const statusField = (body.status || body.code || '').toString().toLowerCase();
              const msgField = (body.message || '').toString().toLowerCase();
              return statusField === 'duplicate' || msgField.includes('duplicate');
            } catch (e) { return false; }
          })();

          if (status === 201) {
            setLoading(false);
            handleClose();
            onSubmit();
            toast.success(
              `External PBM ID -  ${extPBMToSave.extPbmId} Added Successfully`,
              toasterConfig
            );
          } else if (status === 200 && isDuplicate) {
            setLoading(false);
            toast.error(
              `External PBM ID - ${extPBMToSave.extPbmId} already exists`,
              toasterConfig
            );
          } else {
            setLoading(false);
            toast.error(
              "Error while saving new External PBM ID",
              toasterConfig
            );
          }
        })
        .catch(function (err) {
          console.error("Add External PBM error", err);
          setLoading(false);
          toast.error("Error while saving new External PBM ID", toasterConfig);
        });

    }
  };


  const toasterConfig = {
    position: "top-right",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true
  };

  const handleClose = () => {
    onClose();
  };

  useEffect(() => {
    if (recordForEdit != null)
      setValues({
        ...recordForEdit
      })
  }, [recordForEdit])


  return (
    <Dialog

      fullWidth
      maxWidth="md"
      open={true}
      PaperProps={{ variant: "elevation14" }}


    >
      <Paper>
        <Form onSubmit={handleSubmit}>

          <DialogTitle className={classes.dialogTitle}>

            <div style={{ display: 'flex' }}>
              <br></br>
              <Typography variant="h6" component="div" style={{ flexGrow: 5 }}>
                Add New PBM
              </Typography>

            </div>
          </DialogTitle>

          <DialogContent dividers PaperProps={{ variant: "elevation14", sx: { width: "150%", maxHeight: 300 } }} >

            <Grid container>
              <Grid item xs={6}>

                <Grid item xs={12}>
                  <Controls.Input
                    name="extPBMId"
                    label="Ext PBM ID*"
                    inputProps={{
                      maxLength: 10,
                      style: { textTransform: "uppercase" }
                    }}
                    value={values.extPBMId}
                    onChange={handleInputChange}
                    error={errors.extPBMId}

                  />
                </Grid>

                <Grid item xs={12}>
                  <Controls.Input
                    name="extPBMName"
                    label="Ext PBM Name*"
                    inputProps={{
                      maxLength: 25,
                      textTransform: "uppercase"
                    }}
                    value={values.extPBMName}
                    onChange={handleInputChange}
                    error={errors.extPBMName}
                  />

                </Grid>
                <Grid item xs={12}>
                  <Controls.Input
                    name="extPBMUUID"
                    label="Ext PBM UUID*"
                    inputProps={{
                      maxLength: 36
                    }}
                    value={values.extPBMUUID}
                    onChange={handleInputChange}
                    error={errors.extPBMUUID}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Controls.DatePicker
                    name="fromDate"
                    label="From Date*"
                    value={values.fromDate}
                    onChange={handleInputChange}
                    error={errors.fromDate}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Controls.DatePicker
                    name="thruDate"
                    label="Thru Date*"
                    value={values.thruDate}
                    onChange={handleInputChange}
                    error={errors.thruDate}
                  />
                </Grid>


              </Grid>
              <Grid item xs={6}>

                <Grid item xs={12}>
                  <Controls.Input

                    inputProps={{
                      maxLength: 8
                    }}
                    name="bin"
                    label="BIN"
                    value={values.bin}
                    onChange={handleInputChange}
                    error={errors.bin}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Controls.Input
                    name="pcn"
                    label="PCN"
                    inputProps={{
                      maxLength: 10,
                      textTransform: "uppercase"
                    }}
                    value={values.pcn}
                    onChange={handleInputChange}

                  />
                </Grid>
                <Grid item xs={12}>
                  <Controls.Input
                    name="group"
                    label="Group"
                    inputProps={{
                      maxLength: 15,
                      textTransform: "uppercase"
                    }}
                    value={values.group}
                    onChange={handleInputChange}

                  />
                </Grid>
                <Grid item xs={12}>
                  <Controls.Input
                    name="disocuntCHID"
                    label="Ext Disc CHID"
                    inputProps={{
                      maxLength: 20
                    }}
                    value={values.disocuntCHID}
                    onChange={handleInputChange}

                  />

                </Grid>
                

              </Grid>
            </Grid>

          </DialogContent>
          <DialogContent dividers>
            <DialogActions style={{ width: '100%', justifyContent: 'center', display: 'flex', columnGap: 16 }}>
              <Controls.Button
                type="submit"
                variant="contained"
                autofocus
                disabled={!enableSubmit}
                text="SUBMIT"
              />
              <Controls.Button
                text="CANCEL"
                color="default"
                onClick={() => onClose()}
              />
              <PerksPageLoader show={loading} />
            </DialogActions>
          </DialogContent>
        </Form>
      </Paper>
    </Dialog>
  )
}



